import React from "react"
import { ContentfulContentBaseProps } from "../types"
import TextSlider, { TextBlockProps } from "@components/TextSlider"
import * as R from "ramda"

interface ContentfulTextSliderProps extends ContentfulContentBaseProps {}

const formatTextBlock = ({ header, body, backgroundImage }) => ({
  header,
  body: body?.body,
  backgroundImage: backgroundImage?.file?.url,
})

const ContentfulTextSlider: React.FC<ContentfulTextSliderProps> = ({
  blockId,
  textBlocks,
}) => {
  const validTextBlocks = textBlocks.filter(
    ({ backgroundImage }) => !!backgroundImage
  )
  return (
    <TextSlider
      blockId={blockId}
      textBlocks={
        R.map(formatTextBlock)(validTextBlocks) as Array<TextBlockProps>
      }
      maxCount={validTextBlocks.length}
    />
  )
}

export default ContentfulTextSlider
